function showToast(message = "Produit ajouté au panier ✅") {
  const toast = document.getElementById("toast");
  toast.textContent = message;
  toast.classList.add("show");

  // Disparaît après 3 secondes
  setTimeout(() => {
    toast.classList.remove("show");
  }, 3000);
}

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountContainer = document.getElementById('CartCount');
      const cartCountContainer2 = document.getElementById('CartCount2');
      const cartCountValue = document.getElementById('cart-item-count');
      const cartCountValue2 = document.getElementById('cart-item-count2');

      if (cart.item_count > 0) {
        // Si le compteur existe déjà
        if (cartCountValue) {
          cartCountValue.textContent = cart.item_count;
        } else {
          // Si le compteur n'existe pas encore, on le crée
          const cartIcon = document.querySelector('.site-header__cart');
          const div = document.createElement('div');
          div.id = 'CartCount';
          div.className = 'site-header__cart-count';
          div.innerHTML = `<span id="cart-item-count">${cart.item_count}</span>`;
          cartIcon.appendChild(div);
          
        }
        if(cartCountValue2){
          cartCountValue2.textContent = cart.item_count;
        }else{
          const cartIcon2 = document.querySelector('.site-header__cart2');
          const div2 = document.createElement('div');
          div2.id = 'CartCount2';
          div2.className = 'site-header__cart-count';
          div2.innerHTML = `<span id="cart-item-count2">${cart.item_count}</span>`;
          cartIcon2.appendChild(div2);
        }

      } else {
        // Si panier vide → supprimer le compteur
        if (cartCountContainer) {
          cartCountContainer.remove();
        }
        if (cartCountContainer2) {
          cartCountContainer2.remove();
        }
      }
    })
    .catch(error => console.error("Erreur mise à jour compteur : ", error));
}

document.querySelectorAll('.product-form').forEach(form => {
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    const formData = new FormData(this);
    const quantity = formData.get('quantity'); // récupère la quantité choisie

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Mise à jour du compteur
      updateCartCount();

      // Reset quantité à 1
      const qtyInput = this.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = 1;

      // Toast avec nom du produit + quantité
      showToast(`${quantity}× "${data.title}" ajouté au panier ✅`);
    })
    .catch(error => console.error("Erreur ajout panier :", error));
  });
});